import { createSlice } from "@reduxjs/toolkit";
import { uploadInvoices } from "./invoices.thunk";
import { loginWithAccessToken, loginWithEmailPass } from "../auth/auth.thunk";

const initialState = {
  uploadedInvoices: [],
};

export const invoiceSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadInvoices.pending, (state) => {
        state.uploadedInvoices = [];
      })
      .addCase(uploadInvoices.fulfilled, (state, action) => {
        state.uploadedInvoices = action.payload;
      })
      .addCase(uploadInvoices.rejected, (state) => {
        state.uploadedInvoices = [];
      });
  },
});

export const selectUploadedInvoices = (state) =>
  state.invoices.uploadedInvoices;

export default invoiceSlice.reducer;
